import React from 'react'
import styles from './styles.css'
import DownIcon from 'react-icons/lib/md/keyboard-arrow-down'
import PropTypes from 'prop-types'

export default class ComponentName extends React.Component {
  static propTypes = {
    marketName: PropTypes.string,
    open: PropTypes.bool
  }
  render() {
    return (
      <div className={styles.container}>
        <div>
          <div
            className={
              this.props.open ? styles.marketNameSelected : styles.marketName
            }
          >
            {this.props.marketName}
          </div>
          <div className={styles.text}>Seleccionar mercado</div>
        </div>
        <div className={styles.iconContainer}>
          <DownIcon size={24} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Button/index.js